import { DISPERSION_SAMPLE_WGSL } from './fragments/refraction-dispersion-wgsl.js';
import { _setDispersionSampleWgsl, registerPbrTransmission } from './pbr-transmission-ext.js';
import { _registerPbrSceneHook } from './pbr-flags.js';

function setPbrDispersion(mat, dispersion) {
  ((mat._subsurface ??= {}).refraction ??= {}).dispersion = dispersion;
  _setDispersionSampleWgsl(DISPERSION_SAMPLE_WGSL);
  _registerPbrSceneHook(registerPbrTransmission);
}

export { setPbrDispersion };
//# sourceMappingURL=set-dispersion.js.map
